import React, { useState } from 'react';
import { Star } from 'lucide-react';

interface EditableStarRatingProps {
  rating: number;
  onRatingChange: (newRating: number) => void;
  size?: 'small' | 'large';
  disabled?: boolean;
  label?: string;
}

export default function EditableStarRating({
  rating,
  onRatingChange,
  size = 'small',
  disabled = false,
  label
}: EditableStarRatingProps) {
  const [hoverRating, setHoverRating] = useState(0);
  const starSize = size === 'large' ? 'h-5 w-5' : 'h-4 w-4';
  
  const handleStarClick = (starValue: number) => {
    if (!disabled) {
      onRatingChange(starValue);
    }
  };

  const handleStarHover = (starValue: number) => {
    if (!disabled) {
      setHoverRating(starValue);
    }
  };

  const handleStarLeave = () => {
    if (!disabled) {
      setHoverRating(0);
    }
  };

  const displayRating = hoverRating || rating;

  return (
    <div className="flex items-center space-x-2">
      {label && (
        <span className="text-xs font-medium text-gray-700">{label}</span>
      )}
      <div className="flex space-x-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => handleStarClick(star)}
            onMouseEnter={() => handleStarHover(star)}
            onMouseLeave={handleStarLeave}
            disabled={disabled}
            className={`transition-colors ${
              disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:scale-110'
            }`}
          >
            <Star
              className={`${starSize} ${
                star <= displayRating 
                  ? 'text-yellow-400 fill-yellow-400' 
                  : 'text-gray-300'
              }`}
            />
          </button>
        ))}
      </div>
      <span className="text-sm font-bold text-gray-900">
        {rating.toFixed(1)}
      </span>
    </div>
  );
}
